<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-autocomplete
        v-if="inputState === 'userInfo'"
        v-model="selectedUserInfo"
        :items="userInfoItems"
        item-text="text"
        item-value="value"
        label="انتخاب راهنمای کاربر"
        :disabled="disabled"
        :rules="rules"
        class="default-text mb-2"
        outlined
        dense
        autofocus
        @change="addUserInfo"
      />
      <v-textarea
        ref="textarea"
        v-model="text"
        :disabled="disabled"
        :label="label"
        :rules="rules"
        :readonly="inputState !== 'data'"
        class="default-text"
        outlined
        v-bind="$attrs"
        @click="updateCursorPosition"
      >
        <template v-if="!disabled" v-slot:append-outer>
          <div
            v-if="$vuetify.breakpoint.smAndUp"
            class="d-flex flex-column fill-height justify-space-between py-2"
            style="height: 115px"
          >
            <input-generate-menu
              :value="inputState"
              @input="changeInputState"
            />
            <v-btn
              class="px-2"
              style="font-size: 2em"
              text
              title="ایموجی"
              @click="emojiModel = true"
            >
              <div class="pt-1">🙂</div>
            </v-btn>
            <v-btn
              v-if="sendPagesTab !== 1"
              text
              title="لینک کوتاه"
              @click="openLink_ = true"
            >
              <v-icon color="blue lighten-2" large>mdi-link-variant</v-icon>
            </v-btn>
          </div>
        </template>
      </v-textarea>
    </v-col>
    <v-col v-if="$vuetify.breakpoint.xs" cols="12">
      <input-generate-menu :value="inputState" @input="changeInputState" />
      <v-btn
        class="px-2"
        style="font-size: 2em"
        text
        title="ایموجی"
        @click="emojiModel = true"
      >
        <div>🙂</div>
      </v-btn>
      <!-- <v-btn
        v-if="textSuggest"
        class="px-2"
        style="font-size: 2em"
        text
        title="مشاور متن (رایگان)"
        @click="defaultModel = true"
      >
        <div>✉️</div>
      </v-btn>
      <v-btn
        v-else
        class="px-2"
        style="font-size: 2em"
        text
        title="انتخاب کمپین"
        @click="$emit('openCamp')"
      >
        <div>✉️</div>
      </v-btn> -->
    </v-col>
    <custom-popup
      v-model="openLink_"
      :cons="{ title: 'لینک کوتاه' }"
      hide-confirm
      max-width="850"
    >
      <select-short-link
        v-if="openLink_"
        @close="openLink_ = false"
        @select="getShortLink"
      />
    </custom-popup>
    <custom-popup
      v-model="emojiModel"
      :cons="{ title: 'انتخاب ایموجی' }"
      hide-confirm
      max-width="500"
    >
      <emoji-selector :inputBox="$refs.textarea" @close="emojiModel = false" />
    </custom-popup>
    <v-col class="d-block d-sm-flex mt-2" cols="12">
      <p class="mx-2">
        <span v-text="$t('FORMS.CharCount')"></span> :
        <span class="font-weight-bold" v-text="' ' + textInfo.total"></span>
      </p>
      <v-spacer />
      <p class="mx-2">
        <span v-text="$t('FORMS.SmsCount')"></span> :
        <span class="font-weight-bold" v-text="' ' + textInfo.smsCount"></span>
      </p>
      <v-spacer />
      <p class="mx-2">
        <span v-text="$t('FORMS.SmsLang')"></span> :
        <span
          class="font-weight-bold"
          v-text="' ' + $t('LANGUAGE.' + textInfo.lang.name)"
        ></span>
      </p>
      <div class="d-none d-sm-block" style="width: 70px" />
    </v-col>
  </v-row>
</template>

<script>
import EmojiSelector from "./emoji";
import SelectShortLink from "@/view/content/pickers/shortLink/selectShortLink.vue";
import inputGenerateMenu from "../../../../core/plugins/TitleRibbon/components/contacts/pattern/inputGenerateMenu.vue";
import { getTextSmsInfo, Language } from "@/Utilities/Utilities";
import { mapState } from "vuex";
import { debounce } from "@/main";

export default {
  name: "suggestInputPattern",

  components: {
    SelectShortLink,
    EmojiSelector,
    inputGenerateMenu,
  },

  props: {
    rules: Array,
    value: String,
    label: {
      required: false,
    },
    titleInput: [String, Object],
    disabled: Boolean,
    textSuggest: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      emojiModel: false,
      defaultModel: false,
      cons: {
        title: "انتخاب ایموجی",
      },
      cons1: {
        title: "متن پیشفرض",
      },
      textInfo: {
        total: 0,
        farsi: 0,
        smsCount: 0,
        lang: Language.English,
        price: 0,
        coefficient: 1,
        readNumberCount: 0,
      },
      openLink_: false,
      shortLinkUrl: "",
      text: "",
      inputState: "data",
      selectedUserInfo: "",
      cursorIndex: 0,
      userInfoItems: [
        { value: "preName", text: "پیشوند" },
        { value: "name", text: "نام" },
        { value: "middleName", text: "نام میانی" },
        { value: "lastName", text: "نام خانوادگی" },
        { value: "postName", text: "پسوند" },
        { value: "alias", text: "نام مستعار" },
        { value: "companyName", text: "شرکت" },
        { value: "jobTitle", text: "عنوان شغلی" },
        { value: "phone", text: "شماره تلفن" },
        { value: "birthday", text: "تاریخ تولد" },
        { value: "description", text: "توضیحات" },
      ],
    };
  },

  mounted() {
    this.text = this.value || "";
  },

  computed: {
    ...mapState("locals", ["sendPagesTab"]),
  },

  watch: {
    shortLinkUrl(val) {
      if (val) {
        let text = this.text;
        let index = text.indexOf("لغو11");
        if (index === -1) {
          this.text = text + "\n" + val + "\nلغو11";
        } else {
          this.text =
            text.slice(0, index) + "\n" + val + "\n" + text.slice(index);
        }
        this.rerender = false;
        this.$nextTick(() => {
          this.rerender = true;
        });
        this.$emit("input", this.text);
      }
      this.openLink_ = false;
      this.shortLinkUrl = "";
    },
    text(val) {
      debounce(() => {
        this.$emit("input", val);
        let info = getTextSmsInfo(val);
        this.textInfo.total = val.length;
        this.textInfo.farsi = info.persianChar;
        this.textInfo.smsCount = info.smsCount;
        this.textInfo.lang = info.lang;
        this.$nextTick(() => {
          this.$emit("textInfo", this.textInfo);
        });
      }, 200);
    },
    //
    value(val) {
      if (val !== this.text) this.text = val;
    },
    selectedUserInfo(val) {
      if (val && this.inputState === "userInfo") {
        this.addUserInfo();
      }
    },
  },

  methods: {
    changeInputState(state) {
      this.inputState = state;
      if (state === "data") {
        this.selectedUserInfo = "";
        this.$nextTick(() => {
          this.$refs.textarea.$refs.input.focus();
        });
      }
    },
    updateCursorPosition() {
      if (this.inputState === "data") {
        const textarea = this.$refs.textarea.$refs.input;
        this.cursorIndex = textarea.selectionStart;
      }
    },
    addUserInfo() {
      if (this.selectedUserInfo) {
        const selectedItem = this.userInfoItems.find(
          (item) => item.value === this.selectedUserInfo
        );
        const textToInsert = `{${selectedItem.text}}`;
        const before = this.text.slice(0, this.cursorIndex);
        const after = this.text.slice(this.cursorIndex);
        this.text = `${before}${textToInsert}${after}`;
        this.inputState = "data";
        this.selectedUserInfo = "";
        this.$nextTick(() => {
          const textarea = this.$refs.textarea.$refs.input;
          textarea.focus();
          textarea.selectionStart = this.cursorIndex + textToInsert.length;
          textarea.selectionEnd = this.cursorIndex + textToInsert.length;
        });
      }
    },
    // addUserInfo() {
    //   if (this.selectedUserInfo) {
    //     const before = this.text.slice(0, this.cursorIndex);
    //     const after = this.text.slice(this.cursorIndex);
    //     this.text = `${before}{${this.selectedUserInfo}}${after}`;
    //     this.inputState = "data";
    //     this.selectedUserInfo = "";
    //     this.$nextTick(() => {
    //       const textarea = this.$refs.textarea.$refs.input;
    //       textarea.focus();
    //       textarea.selectionStart =
    //         this.cursorIndex + this.selectedUserInfo.length + 2;
    //       textarea.selectionEnd =
    //         this.cursorIndex + this.selectedUserInfo.length + 2;
    //     });
    //   }
    // },
    getShortLink(val) {
      if (val) {
        let text = this.text;
        let index = text.indexOf("لغو11");
        if (index === -1) {
          this.text = text + "\n" + val + "\nلغو11";
        } else {
          this.text =
            text.slice(0, index) + "\n" + val + "\n" + text.slice(index);
        }
        this.$emit("input", this.text);
      }
    },
  },
};
</script>

<style scoped>
.default-text >>> .v-input__append-outer {
  margin: 4px;
  height: 100%;
}
</style>
